// extracted by mini-css-extract-plugin
module.exports = {"container":"message_container__SQAcT","confirm":"message_confirm__csKXr","warning":"message_warning__MqT6j","error":"message_error__1MRIC"};